let _ = t => t,
  _t;
import { Fragment, useMemo } from 'react';
import styledWithTheme from 'foundations-theming/utils';
import { AVATAR_SOURCE_TYPES, DEFAULT_AVATAR_TYPES } from '../../Constants';
import { DEFAULT_ICON_MAP } from '../defaultSvgIcons';
import { AvatarContactInitials } from './AvatarContactInitials';
import { AvatarImage } from './AvatarImage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGWrapper = styledWithTheme.div(_t || (_t = _`
  svg {
    fill: ${0} !important;
    color: ${0} !important;
  }
`), ({
  $iconColor
}) => $iconColor, ({
  $iconColor
}) => $iconColor);
export const AvatarContent = ({
  displayName,
  iconColor,
  iconType,
  size,
  source,
  src
}) => {
  const isDefaultAvatar = useMemo(() => source && [AVATAR_SOURCE_TYPES.DEFAULT_CONTACT_AVATAR, AVATAR_SOURCE_TYPES.DEFAULT_COMPANY_AVATAR].includes(source), [source]);
  const AvatarIcon = iconType ? DEFAULT_ICON_MAP[iconType] : Fragment;
  return /*#__PURE__*/_jsxs(SVGWrapper, {
    $iconColor: iconColor,
    children: [iconType === DEFAULT_AVATAR_TYPES.CONTACT ? /*#__PURE__*/_jsx(AvatarContactInitials, {
      size: size,
      displayName: displayName
    }) : /*#__PURE__*/_jsx(AvatarIcon, {}), /*#__PURE__*/_jsx(AvatarImage, {
      "data-test-id": "avatar-svg-image",
      $size: size,
      $src: isDefaultAvatar ? '' : src,
      "data-source": AVATAR_SOURCE_TYPES.KNOWN_SRC
    })]
  });
};